interface ExtraConfig {
	color?: string
	menu?: string
}

export const extrasConfig: Record<string, ExtraConfig | undefined> = {
	PETIT_DEJ_CL: {
		color: '#FFBD83',
	},
	PAUSE_AM: {
		color: '#FFA3A3',
	},
	DEJ_CL_FOO: {
		color: '#409D54',
		menu: 'https://drive.google.com/drive/u/0/folders/1F3NfB2Ig0swBC51fm5s9zRJfOHK911ou',
	},
	DEJ_CHEF: {
		color: '#7D2EAB',
		menu: 'https://drive.google.com/drive/u/0/folders/1lPJC4z3hk6AgYrP6a3d73yayZbX42KED',
	},
	RESTAURANT_2PLATS: {
		color: '#9D6868',
	},
	PAUSE_PM: {
		color: '#FFA3A3',
	},
	AFTER_WORK: {
		color: '#A61F1F',
	},
	DEJ_MARCHE: {
		color: '#DD8E17',
		menu: 'https://drive.google.com/file/d/1_XKTZHAjlYejrmUAOjWycd8nEmDH-5Vr/view?usp=sharing',
	},
	BREAKFAST: {},
	PETIT_DEJ_PR: {},
	DEJ_CL_CHAUD: {},
	CANCELLATION_INSURANCE: {},
	CUSTOMER_FOOD: {},
	PAYMENT_30: {},
	PAPERBOARD: {},
	DELIVERY_CHEF: {},
	AUTRE: {},
}
